module.exports = __webpack_public_path__ + "static/img/4.29a394c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/sp/4.png
// module id = DDHy
// module chunks = 0